import { render } from "./LoanPage.vue?vue&type=template&id=3d1a89f2"
import script from "./LoanPage.vue?vue&type=script&lang=js"
export * from "./LoanPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__